import CurrentUserService from '../../api/services/currentUserService';

const LOAD_USER_REQUEST = 'dailymile/auth/LOAD_USER';
const LOAD_USER_SUCCESS = 'dailymile/auth/LOAD_USER_SUCCESS';
const LOAD_USER_FAIL = 'dailymile/auth/LOAD_USER_FAIL';

const initialState = {
  loaded: false
};

const handlers = {
  [LOAD_USER_REQUEST]: (state, action) => {
    return {
      ...state,
      loading: true
    };
  },

  [LOAD_USER_SUCCESS]: (state, action) => {
    return {
      ...state,
      loading: false,
      loaded: true,
      user: action.payload.result
    };
  },

  [LOAD_USER_FAIL]: (state, action) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error: action.payload.message
    };
  }
}

export default function reducer(state = initialState, action = {}) {
  if (handlers[action.type]) {
    return handlers[action.type](state, action);
  }
  return state;
}

export function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

export function loadCurrentUser() {
  return {
    description: 'load current user', 
    types: [LOAD_USER_REQUEST, LOAD_USER_SUCCESS, LOAD_USER_FAIL],
    promise: () => CurrentUserService.getCurrentUser()
  };
}


// WEBPACK FOOTER //
// ./src/redux/modules/auth.js